// Form validation utilities

export function validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) && email.length <= 100;
}

export function validateNigerianPhone(phone: string): boolean {
    // Accept both formats: 08012345678 or +2348012345678
    const localFormat = /^0[789]\d{9}$/;  // 0 followed by 7/8/9, then 9 more digits
    const intlFormat = /^\+234[789]\d{9}$/;  // +234 followed by 7/8/9, then 9 more digits
    return localFormat.test(phone) || intlFormat.test(phone);
}

export function validateName(name: string): boolean {
    return name.length >= 3 && name.length <= 100;
}
